// extracted by mini-css-extract-plugin
module.exports = {"section":"_1WDaNp_h2AWdSDPjYjOwR8","container":"_2WDqKcfgE7w1enhQBtayh5"};